import { render } from "./ProductsModal.vue?vue&type=template&id=196a5f37&scoped=true"
import script from "./ProductsModal.vue?vue&type=script&lang=js"
export * from "./ProductsModal.vue?vue&type=script&lang=js"

import "./ProductsModal.vue?vue&type=style&index=0&id=196a5f37&scoped=true&lang=css"

import exportComponent from "/Users/ferlando/Desktop/Baboon/baboon-pos/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-196a5f37"]])

export default __exports__